module.exports = __webpack_public_path__ + "img/1582703965.610f8752.jpg";